module.exports = __webpack_public_path__ + "static/media/date.2ad7ed73.svg";